import React from "react"
import './LoadingComponent.scss'

export const LoadingComponent:React.FC = () => {

    return (
        <div className={'loading-container'}>
            <div className={`loading-outward`}/>
            <div className={`loading-middle`}/>
            <div className={`loading-inward`}>
                {/*<img src="/logo.svg"/>*/}
            </div>
        </div>
    )
}